module.exports = __webpack_public_path__ + "img/icon1.861561b7.png";